import React, { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import cn from "classnames";
import { BlogSidebar } from "./BlogSidebar";
import CTA from "./CTASticky/CTA";
import CTATablet from "./CTASticky/CTATablet";
import CTAMobile from "./CTASticky/CTAMobile";
import { BlogCardType } from "@/components/page-modules/blog/data/blog.types";
import style from "../BlogPage.module.scss";
export const BlogMain: React.FC<BlogCardType> = ({
  blogData
}) => {
  const blogHeading = blogData.blogHeading;
  const blogContentRef = useRef<HTMLDivElement>(null);
  const isTablet = useMediaQuery({
    minWidth: 600,
    maxWidth: 1280
  });
  const isMobile = useMediaQuery({
    maxWidth: 600
  });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return <section className={style.main__content} data-sentry-component="BlogMain" data-sentry-source-file="BlogMain.tsx">
      <div className={cn(style.sidebar_wrap, {
      [style.isMobile]: isTablet || isMobile
    })}>
        <BlogSidebar blogHeading={blogHeading} isOpen={isOpen} setIsOpen={setIsOpen} data-sentry-element="BlogSidebar" data-sentry-source-file="BlogMain.tsx" />
        {isTablet ? <CTATablet /> : isMobile ? <CTAMobile /> : <CTA />}
      </div>

      <div className="blog__wrapper">
        <div className={cn(style.article, "container")} ref={blogContentRef} dangerouslySetInnerHTML={{
        __html: blogData.body
      }} />

      </div>
    </section>;
};